export default "__VITE_ASSET__0NfGqa4Y__"